export default __webpack_public_path__ + "static/media/section1_tool_bubble.f08f1e6b.svg";